import { render } from "./Pricing.vue?vue&type=template&id=bfcf515a&scoped=true"
const script = {}

import "./Pricing.vue?vue&type=style&index=0&id=bfcf515a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcf515a"]])

export default __exports__